import React from "react";
import Card from "react-bootstrap/Card";
import { useTranslation } from "react-i18next";  // Ajout du hook de traduction

function AboutCard() {
  const { t } = useTranslation(); // Hook pour récupérer la traduction

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "center", marginBottom: "2rem", fontSize: "1.15rem", letterSpacing: "0.5px"}}>
            {t("about_me")}
          </p>
          <p className="profile-signature">
            <em>“{t("quote")}”</em>{" "}
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
